// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1toV9","left":"styles_left__3zg4x","desktopActions":"styles_desktopActions__WOj_N","title":"styles_title__3yCoI"};